/**
 * Copyright © 2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { useNavigate } from "react-router-dom";

import { saveScrollYPosition } from "../../../util/helpers";

import { NavDestination } from "./useNavDestinations";

export const useNavigateToItem = () => {
  const navigate = useNavigate();

  return (item: NavDestination) => {
    if (item.scrollYKey) {
      saveScrollYPosition({ sessionStorageKey: item.scrollYKey, position: 0 });
    }
    navigate(item.to);
  };
};
